import * as React from "react";

import styles from "./critical.scss";

const SkeletonTabs = () => <div className={styles.tabs} />;

export default SkeletonTabs;
